import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';

import TextField from '../TextField';
import * as Styled from './style';

function Search({ search, handleSearch }) {
  return (
    <Styled.Field>
      <Styled.SearchContainer>
        <TextField
          name="search"
          placeholder="search..."
          value={search}
          onChange={(event) => handleSearch(event.target.value)}
        />
        <Styled.SearchIcon title="search-icon" />
        {search !== '' && (
          <Styled.CloseButton
            role="button"
            type="button"
            onClick={() => handleSearch('')}
          >
            <AiOutlineCloseCircle title="close-icon" size="1.5em" />
          </Styled.CloseButton>
        )}
      </Styled.SearchContainer>
    </Styled.Field>
  );
}

export default Search;
